import { render, staticRenderFns } from "./qz-tray-options.vue?vue&type=template&id=6175355f&"
import script from "./qz-tray-options.vue?vue&type=script&lang=js&"
export * from "./qz-tray-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports